import { useQuery } from "@tanstack/react-query";
import { getLeadsAffiliateLink } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import type { AffiliateUserRole } from "Types/types";

const AFFILIATE_LINK_QUERY_KEY = "AFFILIATE_LINK";

export const affiliateLinkKeys = {
  all: [AFFILIATE_LINK_QUERY_KEY],
  byRole: (role: AffiliateUserRole) => [AFFILIATE_LINK_QUERY_KEY, role],
};

export const useGetAffiliateLink = (userRole: AffiliateUserRole) =>
  useQuery({
    queryKey: affiliateLinkKeys.byRole(userRole),
    queryFn: processResponseWithApiProblemDetails(() =>
      getLeadsAffiliateLink(userRole),
    ),
  });
